import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

import { CheckCircleIcon, CloseCircleIcon } from 'mdi-react';
import classNames from 'classnames';
import _ from 'lodash';

import ExpandingSection from './ExpandingSection';
import friendlyNames, { type FriendlyOrdered } from './friendlyNames';
import NvpDisplay from './NvpDisplay';

const FRIENDLY_NAMES: FriendlyOrdered = [
  { ERROR_DESCRIPTION: 'Error Description:' },
  { DBS_ERROR_VAL: 'DBsign Error Code:' },
  { DBS_ERROR_MSG: 'DBsign Error Message:' },
  { NATIVE_ERROR_VAL: 'Native Error Code:' },
  { NATIVE_ERROR_MSG: 'Native Error Message:' }
];

type Props = {
  classes: any,
  className?: string,
  errorInfo?: Object | null,
  label?: string,
  labelProps?: Object,
  title?: string | null,
  titleProps?: Object,
  iconProps?: Object,
  nvpDisplayProps?: Object,
  expanded?: boolean,
  onExpand?: () => void
};

const ErrorInfo = ({
  classes,
  className,
  label = 'Error Info:',
  labelProps = {},
  iconProps = {},
  nvpDisplayProps = {},
  errorInfo,
  title,
  ...otherProps
}: Props) => {
  const onlyFriendlyNames = true;
  const nvpData = friendlyNames(FRIENDLY_NAMES, onlyFriendlyNames).applyToArray(
    friendlyNames.toArray(errorInfo || {})
  );

  const errorInfoIsSet = _.isObject(errorInfo) && !_.isEmpty(errorInfo);

  let success = true;

  let _errVal = undefined;
  if (errorInfoIsSet && _.has(errorInfo, 'DBS_ERROR_MSG')) {
    _errVal = parseInt(_.get(errorInfo, 'DBS_ERROR_VAL', undefined), 10);
    if (_.isNumber(_errVal)) {
      _errVal = _.toSafeInteger(_errVal);
    }
    success = _errVal === 0;
  }

  let _errorMsg = title;
  if (errorInfoIsSet && !_.isString(_errorMsg)) {
    _errorMsg = _.get(errorInfo, 'DBS_ERROR_MSG', undefined);
    if (_.isString(_errorMsg) && _.isNumber(_errVal) && _errVal !== 0) {
      _errorMsg = _errorMsg + ' (' + String(_errVal) + ')';
    }
  }

  const IconComponent = success ? CheckCircleIcon : CloseCircleIcon;
  const colorClass = classNames({
    [classes.colorPrimary]: !errorInfoIsSet,
    [classes.colorError]: errorInfoIsSet && !success,
    [classes.colorSuccess]: errorInfoIsSet && success
  });

  const icon = <IconComponent className={colorClass} {...iconProps} />;

  const labelClassNames = classNames(colorClass, labelProps.className);
  const combinedLabelProps = { className: labelClassNames, ...labelProps };

  return (
    <div className={classNames(classes.root, className)}>
      <ExpandingSection
        label={label}
        labelProps={combinedLabelProps}
        icon={icon}
        expandButton={!_.isEmpty(nvpData)}
        title={_errorMsg}
        {...otherProps}
      >
        <NvpDisplay
          className={classes.nvpDisplay}
          nvpData={nvpData}
          keyProps={combinedLabelProps}
          dividers
          dividerBefore
          dividerAfter
          {...nvpDisplayProps}
        />
      </ExpandingSection>
    </div>
  );
};

const styles = ({ spacing: { unit: spacing }, palette: { primary: primaryColorInfo } }) => ({
  root: {},
  colorPrimary: {
    color: primaryColorInfo.main
  },
  colorSuccess: {
    color: green[800]
  },
  colorError: {
    color: red[800]
  },
  colorDividerError: {
    backgroundColor: red[800]
  },
  nvpDisplay: {
    marginLeft: spacing * 4
  }
});

export default withStyles(styles)(ErrorInfo);
